(function () {
  var center = document.querySelector('[data-zs-contact-center]');
  if (!center || center.getAttribute('data-zs-ready') === 'true') return;
  center.setAttribute('data-zs-ready', 'true');

  var buttons = center.querySelectorAll('[data-zs-contact-topic]');
  var select = center.querySelector('[data-zs-contact-select]');
  var helper = center.querySelector('[data-contact-helper]');
  var subject = center.querySelector('[data-zs-contact-subject]');
  var tags = center.querySelector('[data-zs-contact-tags]');
  var reference = center.querySelector('[data-zs-contact-reference]');
  var form = center.querySelector('form');
  var submit = center.querySelector('[data-zs-contact-submit]');

  function slugify(value) {
    return value.toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function activateTopic(value, focusField) {
    var selectedButton = null;
    buttons.forEach(function (button) {
      var active = button.getAttribute('data-zs-contact-topic') === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) selectedButton = button;
    });

    if (select) select.value = value;
    if (helper) {
      helper.textContent = selectedButton ? selectedButton.getAttribute('data-zs-contact-helper-text') : 'Describe the type of assistance you need.';
    }

    if (subject) subject.value = 'ZUPPER Contact Center - ' + value;
    if (tags) tags.value = 'storefront,contact-center,' + slugify(value);
    if (focusField && reference) reference.focus();
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      activateTopic(button.getAttribute('data-zs-contact-topic'), true);
    });
  });

  if (select) {
    select.addEventListener('change', function () {
      activateTopic(select.value, false);
    });
  }

  if (form && submit) {
    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;
      form.setAttribute('aria-busy', 'true');
      submit.disabled = true;
      submit.textContent = 'Sending...';
    });
  }

  var requestedTopic = new URLSearchParams(window.location.search).get('topic');
  var topicAliases = {
    'product-model-matching': 'Product & Model Matching',
    'order-delivery': 'Order & Delivery',
    'returns-warranty': 'Returns & Warranty',
    'wholesale-request-quote': 'Wholesale & Request a Quote'
  };
  activateTopic(topicAliases[requestedTopic] || (select ? select.value : 'Product & Model Matching'), false);
})();
